// 这里会放公共的网络请求
import requestManager from './RequestManager';
// 基本是用来做超时-后续其实想做的是

// import { useStore, useData } from '../store';
// const { scan_token, mini_token, channel } = useStore();
// const { init_data } = useData();
import log, { logNoUa } from './log';

class Semaphore {
  constructor(maxConcurrency) {
    this.maxConcurrency = maxConcurrency;
    this.currentConcurrency = 0;
    this.queue = [];
  }

  acquire() {
    if (this.currentConcurrency < this.maxConcurrency) {
      this.currentConcurrency++;
      return Promise.resolve();
    } else {
      return new Promise((resolve) => {
        console.log(resolve, '添加');
        this.queue.push(resolve);
      });
    }
  }

  release() {
    if (this.queue.length > 0) {
      const next = this.queue.shift();
      console.log(next, '拿出来');
      next();
    } else {
      this.currentConcurrency--;
    }
  }
}
const semaphore = new Semaphore(5);

const headers = new Headers({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'Accept-Language': 'zh-CN,zh;q=0.9', // 设置返回中文
  'Cache-Control': 'no-cache', // 不使用缓存
  Pragma: 'no-cache',
});



async function init() {
  return await get(`${import.meta.env.VITE_BASEAPI}/${import.meta.env.VITE_TEAM}/api/init`);
}

async function get_rank(params) {
  const param = new URLSearchParams(params);
  return await get(`${import.meta.env.VITE_BASEAPI}/${import.meta.env.VITE_TEAM}/api/ranks_v2?${param}`);
}

async function get_role(params) {
  const param = new URLSearchParams(params);
  return await get(`${import.meta.env.VITE_BASEAPI}/${import.meta.env.VITE_TEAM}/api/role_info_v2?${param}`);
}

async function get_search(params) {
  const param = new URLSearchParams(params);
  return await get(`${import.meta.env.VITE_BASEAPI}/${import.meta.env.VITE_TEAM}/api/search_v2?${param}`);
}


async function get_copyright() {
  // 获取页脚内容
  return await get("https://websource.nie.netease.com/copyright/get/byreferer");
}


// 这里将会封装一个get请求，里面会做一些操作:
async function get(url, route, timeout = 10000) {
  await semaphore.acquire();
  return new Promise((resolve, reject) => {
    // 进行权限检查
    // if (!checkAuth()) {
    //     semaphore.release()
    //     resolve({
    //         status: '404',
    //         message: "没有权限访问"
    //     })
    //     return false
    // }

    const controler = new AbortController();
    const signal = controler.signal;
    requestManager.addRequest(url, signal);
    const timer = setTimeout(() => {
      requestManager.removeRequest(url);
      controler.abort();
      clearTimeout(timer);
      semaphore.release();
      logNoUa({
        message: '请求超时',
        url: url,
      });
      reject(new Error('Request time out '));
    }, timeout);
    // 请求进入拦截
    // if (scan_token.value) {
    //   headers.set('tx-scan-token', scan_token.value);
    // }

    // if (mini_token.value) {
    //   headers.set('tx-mini-token', mini_token.value);
    // }

    // if (channel.utm_source == 'gw' && channel.extra == 'gw') {
    //   headers.set('Tx-Platform', channel.utm_source);
    // }
    // if (channel.extra && channel.extra !== 'gw') {
    //   headers.set('Tx-Platform', channel.extra);
    // }
    // if (channel.utm_source && channel.utm_source !== 'gw') {
    //   headers.set('Tx-Platform', channel.utm_source);
    // }

    // headers.set('Cache-Control', 'no-cache, no-store, must-revalidate');
    // headers.set('Pragma', 'no-cache');
    // headers.set('Expires', '0');


    // fetch(url, { signal, headers, credentials: 'include', cache: 'no-store' })
    // console.log(url, headers);
    fetch(url, { 
      method: 'GET', 
      signal, 
      headers, 
      credentials: 'include', 
      cache: 'no-store' 
    })
      .then((res) => {
        clearTimeout(timer);
        requestManager.removeRequest(url);
        if (!res.ok) {
          // 做下响应拦截
          let error = handleNetWorkError(res.status);
          semaphore.release();
          reject(error);
        }

        return res.json();
      })
      .then((data) => {
        semaphore.release();
        resolve(data);
        // 请求从响应出来之后
      })
      .catch((error) => {
        semaphore.release();
        reject(error);
      });
  });
}

//todo:在这里进行重写
// 这里会封装post请求，里面会做一些操作
// 请求的地址，数据，route
async function post(url, data, timeout = 10000) {
  await semaphore.acquire();
  return new Promise((resolve, reject) => {
    const controler = new AbortController();
    const signal = controler.signal;
    requestManager.addRequest(url, signal);

    const timer = setTimeout(() => {
      requestManager.removeRequest(url);
      controler.abort();
      clearTimeout(timer);
      semaphore.release();
      reject(new Error('Request time out '));
    }, timeout);

    // if (mini_token.value) {
    //   headers.set('tx-mini-token', mini_token.value);
    // }

    fetch(url, {
      signal,
      headers,
      body: JSON.stringify(data),
      method: 'POST',
      credentials: 'include',
    })
      .then((res) => {
        clearTimeout(timer);
        requestManager.removeRequest(url);
        if (!res.ok) {
          // 做下响应拦截
          let error = handleNetWorkError(res.status);
          semaphore.release();
          reject(error);
        }

        return res.json();
      })
      .then((data) => {
        semaphore.release();
        resolve(data);
        // 请求从响应出来之后
      })
      .catch((error) => {
        semaphore.release();
        reject(error);
      });
  });
}

// async function set_share_info(data) {
//   return await post(
//     `${import.meta.env.VITE_BASEAPI}/tx3/fcwgxt/set_share_info`,
//     data
//   );
// }


async function collect_log(data) {
  const params = {
    activity: import.meta.env.VITE_NAME,
    h5user_id: window.figureCode,
    details: { "page_name": "home" },
    // account_id: init_data?.account_data?.username || '',
  }
  const data2 = { ...params, ...data }
  return await post(
    `${import.meta.env.VITE_BASEAPI}/tx3/us/collect_log`,
    data2
  );
}


function handleNetWorkError(errStatus) {
  let errorMessage = '未知错误';
  switch (errStatus) {
    case 400:
      errorMessage = '错误的请求';
      break;
    case 401:
      errorMessage = '未授权，请重新登录';
      break;
    case 403:
      errorMessage = '拒绝访问';
      break;
    case 404:
      errorMessage = '请求错误，未找到资源';
      break;
    case 405:
      errorMessage = '请求方法不允许';
      break;
    case 408:
      errorMessage = '请求超时';
      break;
    case 500:
      errorMessage = '服务端出错';
      break;
    case 501:
      errorMessage = '网络未实现';
      break;
    case 502:
      errorMessage = '网络错误';
      break;
    case 503:
      errorMessage = '服务不可用';
      break;
    case 504:
      errorMessage = '网络超时';
      break;
    case 505:
      errorMessage = 'http版本不支持该请求';
      break;
    default:
      errorMessage = `其他连接错误-${errStatus}`;
  }
  // 这里要记下日志
  return errorMessage;
}

export {
  init,
  get_rank,
  get_role,
  get_search,
  get,
  post,
  // set_share_info,
  collect_log,
  get_copyright,
};
